module.exports = __webpack_public_path__ + "img/close.b4918ee8.svg";